/* eslint-disable import/no-cycle */
import {decorate, observable} from 'mobx';
import {EntityStore} from './entityStore';
import {Api} from '../middleware/api';
import {LdapConnection} from '../models/ldapConnection';
import {ldapConnectionEndpoint} from '../middleware/endpoints/ldapConnection';

export class LdapConnectionStore extends EntityStore {
  ldapConnections = []; // not used
  ldapConnection;

  constructor(rootStore) {
    super(rootStore, 'ldapConnections', Api.ldapConnection, LdapConnection);
  }

  getOnly() {
    this.loadAll({raw: true, apiEndpoint: ldapConnectionEndpoint})
      .then((value) => {
        this.ldapConnection = value.data;
      });
  }
}

decorate(LdapConnectionStore, {
  ldapConnection: observable,
});
